import * as types from '../constants/actionTypes';

export function formInput(value, name) {
    return { type: types.FORM_INPUT, value, name };
}

export function formError(name, error) {
    return { type: 'FORM_ERROR', name, error };
}

export function clearFormErrors() {
    return { type: types.CLEAR_FORM_ERRORS }
}

// ACCOUNT
export function resetPasswordResult() {
    return { type: types.CLEAR_RESETPASSWORD_USER };
}

export function clearForgotPassword() {
    return { type: types.CLEAR_FORGETPASSWORD_USER };
}

// LOGIN
export function initializeLoginForm() {
    return { type: types.INIT_LOGIN };
}

export function initializeChangePasswordForm(userName) {
    return { type: types.INIT_CHANGEPASSWORD_FORM, userName };
}

export function clearEmployeeChangePasswordForm() {
    return { type: types.CLEAR_EMPLOYEECHANGEPASSWORD_FORM };
}

export function clearFormInput(name) {
    return { type: types.CLEAR_FORM_INPUT, name: name };
}

export function setBulkTransferBranchFrom(branchId) {
    return { type: 'SET_BULK_TRANSFER_BRANCH_FROM', branchId: branchId, };
}

export function setBulkTransferBranchTo(branchId) {
    return { type: 'SET_BULK_TRANSFER_BRANCH_TO', branchId: branchId, };
}

export function initializeForm() {
    return { type: types.INITIALIZE_STORE_PRODUCT };
}

export function initializeRole(compName){
    return { type: types.INITIALIZE_ROLE, compName }
}

export function initializeFormPatient() {
    return { type: types.INITIALIZE_STORE_PATIENT };
}

export function initializeBankDepositForm(name) {
  return { type: types.BANKDEPOSITS_INITIALIZE_STORE, compName: name };
}

export function initializeVendorForm(name) {
    return { type: types.INITIALIZE_STORE_VENDOR, compName: name };
}

export function initializeProductForm(name) {
    return { type: types.INITIALIZE_STORE_PRODUCT, compName: name };
}

export function loadProductPriceMatrixTable(name, priceMatrix) {
    return { type: types.LOAD_PRODUCT_PRICE_MATRIX_TABLE, compName: name, priceMatrix: priceMatrix };
}

export function clearStoreProductForType(name) {
    return { type: types.INITIALIZE_STORE_PRODUCT_CHANGE_TYPE, compName: name };
}

export function initializePOProductForm(name) {
    return { type: types.INITIALIZE_STORE_PO_PRODUCT, compName: name };
}

export function initializePurchaseOrderForm(name) {
    return { type: types.INITIALIZE_STORE_PURCHASEORDER, compName: name };
}

export function initReceivePurchaseOrder() {
    return { type: types.INITIALIZE_STORE_RECEIVE_PURCHASEORDER };
}

export function loadPOProductItem(name, productId, productList) {
    return { type: types.LOAD_PO_PRODUCT, compName: name, productId, productList };
}

// DOCTOR
export function initializeDoctorForm(compName) {
    return { type: types.INITIALIZE_STORE_DOCTOR, compName };
}

export function loadDoctorForm(id, compName, branchId) {
    return { type: types.DOCTOR_EDIT_LOAD, id, compName, branchId };
}

// MANAGE
// WEIGHT
export function initializeWeightSettingForm(compName) {
    return { type: types.INITIALIZE_STORE_WEIGHT_SETTING, compName };
}

// PRICE MATRIX
export function initializePriceMatrixForm(compName) {
    return { type: types.INITIALIZE_STORE_PRICE_MATRIX, compName };
}

export function applyMemberPrice(discount, compName) {
    return { type: types.APPLY_MEMBER_DISCOUNT_PRICE_MATRIX, discount, compName };
}

// DEVICE
export function initializeDeviceForm(compName) {
    return { type: types.INITIALIZE_STORE_DEVICE, compName };
}

export function getIPAddress(ipaddress, compName) {
    return { type: types.GETIPADDRESS, ipaddress, compName };
}

export function updateIpAddress(ipaddress, compName) {
    return { type: types.UPDATEIPADDRESS, ipaddress, compName };
}

// DEVICE ROLE
export function initializeDeviceRoleForm(compName) {
    return { type: types.INITIALIZE_STORE_DEVICE_ROLE, compName };
}

// DEVICE WORKSTATION
export function initializeDeviceWorkStationForm(compName) {
    return { type: types.INITIALIZE_STORE_DEVICE_WORKSTATION, compName };
}

// PAYMENT
export function initializePaymentForm(compName) {
    return { type: types.INITIALIZE_STORE_PAYMENT, compName };
}

// TAXRATE
export function initializeTaxRateForm(compName) {
    return { type: types.INITIALIZE_STORE_TAXRATE, compName };
}

// EMPLOYEE
export function initializeEmployeeForm(compName, branchId) {
    return { type: types.INITIALIZE_STORE_EMPLOYEE, compName, branchId };
}

// POS
export function linkPatientToOrder(patient, compName) {
    return { type: types.LINK_PATIENT_POS_ORDER, patient, compName };
}

export function initializeStorePOSAddProduct(compName) {
    return { type: types.INITIALIZE_POS_ADD_PRODUCT, compName };
}

export function addProductToPOSOder(product) {
    return { type: types.ADD_PRODUCT_TO_POS_ORDER, product };
}

export function addComboProductToPOSOrder(comboProducts) {
    return { type: types.ADD_COMBO_PRODUCT_TO_POS_ORDER, comboProducts };
}

export function initializeStorePOS() {
    return { type: types.INITIALIZE_STORE_POS };
}

export function initializeStorePOSPatient(compName) {
    return { type: types.INITIALIZE_STORE_POS_PATIENT, compName };
}

export function clearPOSCancellation() {
    return { type: types.CLEAR_POS_CANCELLATION };
}

export function clearAdminOrderCancellation() {
    return { type: types.CLEAR_ADMIN_ORDER_CANCELLATION };
}


export function initializeStoreRemoveDiscount(compName) {
    return { type: types.INITIALIZE_STORE_POS_REMOVE_DISCOUNT, compName };
}

export function initializeStoreDiscount(compName, productsCompName) {
    return { type: types.INITIALIZE_STORE_POS_DISCOUNT, compName, productsCompName };
}

// TRANSFER
export function clearWarehouseTableData(compName) {
    return { type: types.CLEAR_WAREHOUSE_DATA, compName };
}

// PRODUCT CATEGORY
export function initializeProductCategoryForm(compName) {
    return { type: types.CLEAR_PRODUCT_CATEGORY_FORM, compName };
}

//CAMPAIGN
export function initializeCampaignForm(compName) {
    return { type: types.CLEAR_CAMPAIGN_FORM, compName };
}

export function clearDialogItemsCampaign(compName) {
    return { type: types.CLEAR_CAMPAIGN_ITEMS_DIALOG, compName };
}

//COMBO
export function initializeComboForm(compName) {
    return { type: types.CLEAR_COMBO_FORM, compName };
}

export function clearDialogItemsCombo(compName) {
    return { type: types.CLEAR_COMBO_ITEMS_DIALOG, compName };
}

//CUSTOM DISCOUNTS
export function initializeCustomizedDiscountForm(compName) {
    return { type: types.CLEAR_DISCOUNT_FORM, compName };
}

//REFUND
export function cleanRefundForm(compName) {
    return { type: types.CLEAN_REFUND_FORM, compName };
}

// SHIFT
export function clearEmployeeShiftForm(compName) {
    return { type: types.CLEAN_EMPLOYEE_SHIFT_FORM, compName };
}

// MIX AND MATCH
export function cleanMixAndMatchForm(compName) {
    return { type: types.CLEAN_MIX_AND_MATCH_FORM, compName };
}

// PRODUCT GROUP
export function initializeProductGroupForm(compName) {
    return { type: types.INIT_PRODUCT_GROUP_FORM, compName };
}

export function initializeCarouselProductGroupForm(compName) {
    return { type: types.INIT_CAROUSEL_PRODUCT_GROUP_FORM, compName };
}

export function initializeStoreRulesForm(compName) {
    return { type: types.INIT_STORE_RULES_FORM, compName };
}

export function updateProductCampaigns(campaigns, compName) {
    return { type: types.UPDATE_PRODUCT_CAMPAIGNS, campaigns, compName };
}

export function clearDialogItemsProductGroup(compName) {
    return { type: types.CLEAR_PRODUCT_GROUP_ITEMS_DIALOG, compName };
}

export function clearInventoryAdjust(compName) {
    return { type: types.CLEAR_INVENTORY_ADJUST, compName };
}

export function saveToForm(model) {
    return { type: "SAVE_TO_SCHEDULE_FORM", model };
}

export const clearSchedulesAndEmployees = () => {
    return { type: types.CLEAR_SCHEDULES_AND_EMPLOYEES };
}

export const initializeBannerForm = (compName, payload = {}) => ({
  type: types.INITIALIZE_BANNER_FORM,
  compName,
  payload,
});
